import moment from "moment";

export class TimeUtils {
  static dbTimeColumnToDate(time, uiFormat = 'HH:mm a', dbFormat = 'HH:mm:ss') {
    return moment(time, dbFormat).format(uiFormat);
  }

  static formatTimeRelative(time, relativeTo) {
    return moment(time).from(relativeTo, true);
  }

  static formatTime(time, format = 'DD-MMM h:mm a') {
    return moment(time).format(format);
  }

  static timeDifferenceInMinutes(time1, time2) {
    return moment(time1).diff(moment(time2), 'minutes');
  }
}
